<template>

    <div :class="containerClassName">
        <slot name="preview" :imagePreview="imagePreview">
            <template v-if="imagePreview">
                <div
                        class="fit bg-cover"
                        :style="'background-color: '+defaultBackground+'; background-image: url('+imagePreview+')'"
                ></div>
            </template>
        </slot>

        <div :class="inputFileClassName">
            <input-file
                v-bind="getInputProps({
                    onFileChange: onChangeFile
                })"

                ref="file"
            ></input-file>
        </div>


    </div>

</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinFile from './mixinFile';

    import InputFile from './InputFile';

    export default {
        mixins: [ mixinCommon, mixinFile ],
        components: {
            'input-file': InputFile
        },
        props: {
            ...InputFile.props,

            containerClassName: {
                type: String,
                default: 'position-relative',
            },

            inputFileClassName: {
                type: String,
                default: '',
            },

            accept: {
                type: String,
                default: '.jpg, .jpeg, .JPG, .JPEG, .png, .PNG, .gif, .GIF'
            },

            resizeType: {
                type: String,
                default: 'cover' //or 'contain'
            },
            resizeWidth: {
                type: [Number, String],
                default: 640
            },
            resizeHeight: {
                type: [Number, String],
                default: 640
            },
            defaultBackground: {
                type: String,
                default: '#ffffff'
            },
            defaultImagePreview: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                toResize: this.resizeType || ( this.resizeWidth && this.resizeHeight ),

                imagePreview: this.defaultImagePreview
            };
        },
        watch: {
            resizeType( resizeType ) {
                if( resizeType ) {
                    this.toResize = true;
                }
            },
            resizeWidth( resizeWidth ) {
                if( resizeWidth ) {
                    this.toResize = true;
                }
            },
            resizeHeight( resizeHeight ) {
                if( resizeHeight ) {
                    this.toResize = true;
                }
            },
        },
        mounted() {

        },
        methods: {
            onChangeFile( evt ) {
                evt.preventDefault();

                let file = evt.target.files[0];

                if( this.toResize ) {
                    this.resizeImage(
                        file,
                        ( file, url ) => {
                            this.imagePreview = url;
                            this.blobFile = this.createBlob( file, this.fileName, this.mimeType );
                        }
                    );
                }
                else {
                    let reader = new FileReader();

                    if( !this.validateFile( evt.target ) ) {
                        return false;
                    }

                    reader.onloadend = () => {
                        this.imagePreview = reader.result;
                        this.blobFile = this.createBlob( file, this.fileName, this.mimeType );
                    };

                    reader.readAsDataURL(file);
                }

            },
            resizeImage( file, callback ) {
                if( !file ) {
                    file = this.blobFile;
                }
                let reader = new FileReader();

                reader.onload = ( readerEvent ) => {

                    let image = new Image();
                    image.onload = ( imageEvent ) => {

                        // Resize the image
                        let canvas = document.createElement('canvas'),
                            max_width = this.resizeWidth,
                            max_height = this.resizeHeight,

                            width = image.width, //canvas width
                            height = image.height, //canvas height

                            source_width = image.width,
                            source_height = image.height,
                            dest_width = image.width,
                            dest_height = image.height,
                            source_left = 0,
                            source_top = 0,
                            dest_left = 0,
                            dest_top = 0
                        ;

                        if( this.resizeType === 'contain' ) {
                            if( image.width / image.height >= max_width / max_height ) {
                                width = max_width;
                                height = parseInt( (image.height * max_width) / image.width );
                            }
                            else {
                                width = parseInt( (image.width * max_height) / image.height );
                                height = max_height;
                            }
                            dest_width = width;
                            dest_height = height;

                            source_width = image.width;
                            source_height = image.height;

                            source_left = 0;
                            source_top = 0;
                        }
                        else if( this.resizeType === 'cover' ) {
                            width = max_width;
                            height = max_height;

                            dest_width = width;
                            dest_height = height;

                            source_left = 0;
                            source_top = 0;

                            if( image.width / image.height >= width / height ) {
                                source_top = 0;
                                source_left = parseInt( (image.width - (image.height * (width/height)) ) / 2 );

                                source_width = image.width - (source_left * 2);
                                source_height = image.height;
                            }
                            else {
                                source_top = parseInt( (image.height - (image.width / (width/height)) ) / 2 );
                                source_left = 0;

                                source_width = image.width;
                                source_height = image.height - (source_top * 2);
                            }
                        }

                        canvas.width = width;
                        canvas.height = height;

                        let ctx = canvas.getContext('2d');

                        ctx.fillStyle = this.defaultBackground;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);

                        ctx.drawImage(image, source_left, source_top, source_width, source_height, dest_left, dest_top, dest_width, dest_height);

                        let dataUrl = canvas.toDataURL( this.mimeType );
                        let resizedImage = this.dataURLToBlob(dataUrl);
                        //resizedImage.name = this.fileName;

                        callback( resizedImage, dataUrl );

                        /*$.event.trigger({
                            type: "imageResized",
                            blob: resizedImage,
                            url: dataUrl
                        });*/
                    };
                    image.src = readerEvent.target.result;
                };

                return reader.readAsDataURL(file);
            },


            /*loadImage( selector, evt ) {
                evt.preventDefault();

                $( selector ).trigger('click')
            },*/

            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( InputFile, overrideProps );
            }
        }
    }
</script>
